<p><a routerLink="/feed">See full list of resources...</a></p>
<app-feature id={{id}}></app-feature>
